<nb-card class="bg-transparent">
  <nb-card-header class="pb-0">
    <div class="row">
      <div class="col-lg-4 col-12 text-lg-left">
        <h4 class="fw-semibold ls-1">Pool List</h4>
      </div>
      <div class="col-lg-8 col-12 text-lg-right">
        <div class="d-flex justify-content-end">
          
          <div class="me-3 filter-badge-wrapper">
            <button
              mat-stroked-button
              class="btn text-dark btn-sm"
              (click)="clearFilters()"
            >
              <fa-icon [icon]="faBan" class="me-2"></fa-icon>Clear Filters
            </button>
            <span *ngIf="filterCount > 0" class="filter-badge">{{filterCount}}</span>
          </div>
          
          <button mat-raised-button color="primary" (click)="openDialog(false, null)">
            <fa-icon [icon]="faPlus" size="sm" class="me-2"></fa-icon>
            New Pool
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div>
        <div class="d-flex justify-content-end gap-2">
          <div class="d-flex justify-content-between">
            <button mat-raised-button class="new-compact-btn" (click)="downloadFiles('Excel');">
              <span style="letter-spacing: normal;">
                <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                Excel
              </span>
            </button>
          </div>
        </div>
      </div>
        
    </div>
  </nb-card-header>

  <nb-card-body [nbSpinner]="poolLoading" class="bg-transparent">
    <div class="row grid-wrapper">
      <div class="col-12">
        <ejs-grid #grid [id]="gridName" [dataSource]="allPooType" [allowPaging]="true" [enableHover]="false"
          [allowSelection]="true" (toolbarClick)="toolbarClick($event)" [pageSettings]="pageSettings"
          [allowSorting]="true" [allowExcelExport]="true" [filterSettings]="filterSettings" [allowTextWrap]="true"
          [allowFiltering]="true" [toolbar]="toolbarOptions" [enableStickyHeader]="true" [columns]="allColumns"
          [enablePersistence]="enablePersistence" rowHeight="38"
          (actionComplete)="onActionComplete($event)"
          (dataBound)="onGridDataBound()"
          (rowDataBound)="onRowDataBound($event)">
        </ejs-grid>
      </div>
    </div>
  </nb-card-body>
</nb-card>

<ng-template #isActiveTemplate let-row>
  <div *ngIf="row.isActive" style="color: green;">
    <fa-icon [icon]="faCheck"></fa-icon>
  </div>
  <div *ngIf="!row.isActive" style="color: darkRed;">
    <fa-icon [icon]="faTimes"></fa-icon>
  </div>
</ng-template>

<ng-template #actionTemplate let-row>
  <ng-container *ngIf="!savingPoolIds.has(row.id); else poolSavingSpinner">
    <div class="d-flex">
      <button class="btn btn-sm btn-active-primary btn-icon-hover" (click)="openDialog(true, row)">
        <fa-icon style="cursor: pointer;" [icon]="faPen"></fa-icon>
      </button>
      <button class="btn btn-sm btn-active-primary btn-icon-hover ms-1" (click)="confirmDelete(row.id)">
        <fa-icon style="cursor: pointer;" [icon]="faTrash"></fa-icon>
      </button>
    </div>
  </ng-container>
  <ng-template #poolSavingSpinner>
    <mat-spinner class="row-saving-spinner" [diameter]="20"></mat-spinner>
  </ng-template>
</ng-template>